<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.downtimePlan.new')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/"><i class="fa fa-home"></i></router-link>
                    </li>
                    <!-- <li class="breadcrumb-item">
                        <router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link>
                    </li> -->
                    <li class="breadcrumb-item">
                        <router-link to="/prd/downtimePlan"><span>{{$t('tlt.downtimePlan')}}</span></router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/prd/downtimePlan/edit"><span>{{$t('tlt.downtimePlan.new')}}</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('downtimePlan')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('downtimePlan')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">          
                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.downtimePlan.locId')}}:</label>
                                <dimSearch  validate="required" name="locId"
                                            v-model="locId" :entity="locations" submitProp="id" bindProp="id" bindId="startLocation">
                                </dimSearch>                                
                            </div>  

                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.downtimePlan.locName')}}:</label>
                                <dimSearch  validate="required" name="locName"
                                            v-model="locName" :entity="locations" submitProp="locName" bindProp="locName" bindId="startLocation">
                                </dimSearch>                                
                            </div>

                            <div class="form-group col-md-2" >
                                    <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.downtimePlan.startDate')}}：</label>
                                    <mmf-datepicker      v-model="startDate"></mmf-datepicker>
                            </div> 

                            <div class="form-group col-md-2" >
                                    <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.downtimePlan.endDate')}}：</label>
                                    <mmf-datepicker      v-model="endDate"></mmf-datepicker>
                            </div> 
                        
                            <div class="form-group col-md-8">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.downtimePlan.description')}}:</label>
                                <input v-validate="'required'" name="description"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('description') }"
                                    v-model="description" type="text">
                                <span v-show="errors.has('description')" class="lbl-obg">
                                    {{ errors.first('description') }}
                                </span>
                            </div>                        
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>



<script>
    import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions,
        mapState
    } from "vuex";
    import {
        fields
    } from "@/model/prd/productionPlan/DowntimePlan";
    import dimSearch from "@/components/MMFDimSearch";
    import MmfDatepicker from '@/components/MmfDatepicker';

    const {
        mapFields
    } = createHelpers({
        getterType: 'downtimePlan/getField',
        mutationType: 'downtimePlan/updateField',
    });
    export default {
        data() {
            return {
                         
            }
        },
        beforeMount() {
            this.$store.dispatch('downtimePlan/loadLocations');
        },
        computed: {
            ...mapFields(fields),
            ...mapState({
                locations: state => state.downtimePlan.locations,

            }),          
        },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave"]),            
        },
        components: {
            dimSearch,
            MmfDatepicker
        }
    };
</script>